// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.models_styles .img_card img[data-v-08e943b6] {
  padding: 30px 30px;
}
.custom_size[data-v-08e943b6] {
  max-height: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/NoVehicle.vue"],"names":[],"mappings":";AAUA;EACE,kBAAkB;AACpB;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["<template>\r\n  <div class=\"img_card\">\r\n    <img class=\"img-fluid custom_size\" src=\"../../../../../../images/chat-widget/no-vehicle-image.png\" alt=\"\">\r\n  </div>\r\n</template>\r\n<script>\r\nexport default {\r\n}\r\n</script>\r\n<style scoped>\r\n.models_styles .img_card img {\r\n  padding: 30px 30px;\r\n}\r\n\r\n.custom_size {\r\n  max-height: 200px;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
